// SH locale helper
var __SH_DE = (window.location.pathname.indexOf('/de/') === 0 || window.location.pathname === '/de');
function __sh_t(de, fr) { return __SH_DE ? de : fr; }

(function() {
  'use strict';

  var COLL = window.location.pathname.split('/collections/')[1];
  if (!COLL) return;
  COLL = COLL.split('?')[0].split('/')[0];

  // Collection filter definitions
  var FILTER_DEFS = {

    'pc-gaming': [
      { key: 'gpu', label: __sh_t('Grafikkarte', 'Carte graphique'), extract: function(t, p) { if (p && p.tags) { for (var i=0; i<p.tags.length; i++) { if (p.tags[i].indexOf('gpu:')===0) return p.tags[i].substring(4); } } return null; }},
      { key: 'cpu', label: __sh_t('Prozessor', 'Processeur'), extract: function(t, p) { if (p && p.tags) { for (var i=0; i<p.tags.length; i++) { if (p.tags[i].indexOf('cpu:')===0) return p.tags[i].substring(4); } } return null; }},
      { key: 'ram', label: 'RAM', extract: function(t, p) { if (p && p.tags) { for (var i=0; i<p.tags.length; i++) { if (p.tags[i].indexOf('ram:')===0) return p.tags[i].substring(4); } } return null; }},
      { key: 'ssd', label: __sh_t('Speicher', 'Stockage'), extract: function(t, p) { if (p && p.tags) { for (var i=0; i<p.tags.length; i++) { if (p.tags[i].indexOf('ssd:')===0) return p.tags[i].substring(4); } } return null; }}
    ],

    'carte-mere': [
      { key: 'socket', label: __sh_t('Sockel', 'Socket'), extract: function(t) { var m = t.match(/\b(AM[45]|LGA\s*\d{4,5}(?:\/\d+)?)\b/i); return m ? m[1].replace(/\s+/g,'') : null; }},
      { key: 'format', label: 'Format', extract: function(t) { var m = t.match(/\b(E-ATX|ATX|mATX|Micro-ATX|Mini-ITX|ITX)\b/i); if (!m) return null; var v = m[1]; var map = {'atx':'ATX','e-atx':'E-ATX','eatx':'E-ATX','matx':'mATX','micro-atx':'mATX','mini-itx':'Mini-ITX','itx':'Mini-ITX'}; return map[v.toLowerCase()] || v; }},
      { key: 'chipset', label: 'Chipset', extract: function(t) { var m = t.match(/\b([XBA]\d{3}[A-Z]?)\b/i); return m ? m[1].toUpperCase() : null; }},
      { key: 'wifi', label: 'WiFi', extract: function(t) { return /wifi/i.test(t) ? __sh_t('Ja', 'Oui') : __sh_t('Nein', 'Non'); }}
    ],
    'carte-graphique': [
      { key: 'gpu', label: 'GPU', extract: function(t) { var m = t.match(/\b(RTX\s*\d{4}(?:\s*(?:Ti|SUPER))?)\b/i); if (!m) m = t.match(/\b(RX\s*\d{4}(?:\s*XT)?)\b/i); if (!m) m = t.match(/\b(Arc\s*[AB]\d{3,4})\b/i); return m ? m[1].replace(/\s+/g,' ') : null; }},
      { key: 'vram', label: 'VRAM', extract: function(t) { var m = t.match(/(\d{1,2})\s*G[Bo]/i); return m ? m[1]+__sh_t(' GB', ' Go') : null; }},
      { key: 'marque', label: __sh_t('Marke', 'Marque'), extract: function(t) { var brands = ['ASUS','MSI','Gigabyte','Sapphire','ZOTAC','EVGA','PNY','Palit','Gainward','Inno3D','XFX','PowerColor','ASRock']; for (var b of brands) { if (t.toLowerCase().indexOf(b.toLowerCase()) !== -1) return b; } return null; }}
    ],    'processeur': [
      { key: 'marque', label: __sh_t('Marke', 'Marque'), extract: function(t) { if (/\bIntel\b/i.test(t)) return 'Intel'; if (/\bAMD\b|\bRyzen\b/i.test(t)) return 'AMD'; return null; }},
      { key: 'gamme', label: __sh_t('Serie', 'Gamme'), extract: function(t) { var m = t.match(/\b(Core\s*(?:i[3579]|Ultra\s*\d)(?:\s*\d{4,5}[A-Z]*)?)\b/i); if (!m) m = t.match(/\b(Ryzen\s*[3579]\s*\d{4}[A-Z]*)\b/i); return m ? m[1] : null; }},
      { key: 'coeurs', label: __sh_t('Kerne', 'Coeurs'), extract: function(t) { var m = t.match(/(\d{1,2})\s*(?:-\s*)?(?:Core|Coeurs?|C\b)/i); return m ? m[1]+__sh_t(' Kerne', ' coeurs') : null; }}
    ],
    'ram': [
      { key: 'type', label: 'Type', extract: function(t) { var m = t.match(/\b(DDR[45])(?!.*SO-)/i); if (!m) m = t.match(/(SO-DDR[45])/i); return m ? m[1].toUpperCase() : null; }},
      { key: 'vitesse', label: __sh_t('Geschwindigkeit', 'Vitesse'), extract: function(t) { var m = t.match(/(\d{4,5})\s*MHz/i); return m ? m[1]+' MHz' : null; }},
      { key: 'capacite', label: 'Config', extract: function(t) { var m = t.match(/(\d+x\d+\s*G[Bo]|\d+\s*G[Bo])/i); return m ? m[1] : null; }},
      { key: 'marque', label: __sh_t('Marke', 'Marque'), extract: function(t) { var brands = ['Corsair','G.Skill','Kingston','Crucial','TeamGroup','ADATA']; for (var b of brands) { if (t.toLowerCase().indexOf(b.toLowerCase()) !== -1) return b; } return null; }}
    ],
    'ssd': [
      { key: 'capacite', label: __sh_t('Kapazität', 'Capacite'), extract: function(t) { var m = t.match(/(\d+)\s*(?:To|TB)/i); if (m) return m[1]+__sh_t(' TB', ' To'); m = t.match(/(\d+)\s*(?:Go|GB)/i); return m ? m[1]+__sh_t(' GB', ' Go') : null; }},
      { key: 'format', label: 'Format', extract: function(t) { if (/NVMe|M\.?2/i.test(t)) return 'NVMe M.2'; if (/SATA|2\.5/i.test(t)) return 'SATA 2.5"'; return null; }},
      { key: 'marque', label: __sh_t('Marke', 'Marque'), extract: function(t) { var brands = ['Samsung','WD','Western Digital','Crucial','Kingston','Seagate','Corsair','Sabrent']; for (var b of brands) { if (t.toLowerCase().indexOf(b.toLowerCase()) !== -1) return b; } return null; }}
    ],
    'alimentation': [
      { key: 'watts', label: __sh_t('Leistung', 'Puissance'), extract: function(t) { var m = t.match(/(\d{3,4})\s*W/i); return m ? m[1]+'W' : null; }},
      { key: 'certif', label: __sh_t('Zertifizierung', 'Certification'), extract: function(t) { var m = t.match(/(80\+?\s*(?:Gold|Silver|Bronze|Platinum|Titanium))/i); return m ? m[1] : null; }},
      { key: 'marque', label: __sh_t('Marke', 'Marque'), extract: function(t) { var brands = ['Corsair','be quiet!','Seasonic','EVGA','Cooler Master','MSI','ASUS','Thermaltake','NZXT']; for (var b of brands) { if (t.toLowerCase().indexOf(b.toLowerCase()) !== -1) return b; } return null; }}
    ],
    'boitier': [
      { key: 'format', label: 'Format', extract: function(t) { var m = t.match(/\b(E-ATX|ATX|mATX|Micro-ATX|Mini-ITX|ITX|Mid[- ]?Tower|Full[- ]?Tower)\b/i); return m ? m[1] : null; }},
      { key: 'marque', label: __sh_t('Marke', 'Marque'), extract: function(t) { var brands = ['NZXT','Corsair','be quiet!','Fractal','Lian Li','Cooler Master','Phanteks','MSI']; for (var b of brands) { if (t.toLowerCase().indexOf(b.toLowerCase()) !== -1) return b; } return null; }}
    ],
    'ventirad-watercooling': [
      { key: 'type', label: 'Type', extract: function(t) { if (/AIO|watercooling|liquid|water/i.test(t)) return 'Watercooling'; if (/ventirad|air|tower/i.test(t)) return 'Ventirad'; return null; }},
      { key: 'taille', label: __sh_t('Grösse', 'Taille'), extract: function(t) { var m = t.match(/(\d{2,3})\s*mm/i); return m ? m[1]+'mm' : null; }},
      { key: 'marque', label: __sh_t('Marke', 'Marque'), extract: function(t) { var brands = ['Noctua','be quiet!','Corsair','NZXT','Cooler Master','Arctic','DeepCool']; for (var b of brands) { if (t.toLowerCase().indexOf(b.toLowerCase()) !== -1) return b; } return null; }}
    ],
    'clavier': [
      { key: 'type', label: 'Type', extract: function(t, p) {
        var s = (p && p.body_html ? p.body_html : '') + ' ' + t;
        if (/Touches de clavier:\s*M[ée]canique|\bm[ée]canique\b|mechanical/i.test(s)) {
          if (/Membrane|D[ôo]me en caoutchouc|semi[- ]m[ée]canique/i.test(s)) return __sh_t('Semi-mechanisch', 'Semi-mécanique');
          return __sh_t('Mechanisch', 'Mécanique');
        }
        if (/Membrane|D[ôo]me en caoutchouc/i.test(s)) return __sh_t('Membran', 'Membrane');
        if (/Magnetic|HyperMagnetic|OmniPoint/i.test(s)) return __sh_t('Mechanisch', 'Mécanique');
        return null;
      }},
      { key: 'format', label: 'Format', extract: function(t, p) {
        var s = (p && p.body_html ? p.body_html : '') + ' ' + t;
        if (/\b60\s*%|\bMini\b/i.test(s)) return '60%';
        if (/\b65\s*%/i.test(s)) return '65%';
        if (/\b75\s*%/i.test(s)) return '75%';
        if (/\b96\s*%/i.test(s)) return '96%';
        if (/\bTKL\b|tenkeyless|sans pav[ée] num[ée]rique/i.test(s)) return 'TKL';
        if (/Bloc num[ée]rique:\s*Oui|Pav[ée] num[ée]rique|full[- ]?size/i.test(s)) return 'Full size';
        return null;
      }},
      { key: 'connexion', label: __sh_t('Anschluss', 'Connexion'), extract: function(t, p) {
        var s = (p && p.body_html ? p.body_html : '') + ' ' + t;
        if (/Type de raccordement:\s*Sans c[âa]ble|sans[- ]fil|wireless|Bluetooth|2\.4\s*GHz/i.test(s)) return __sh_t('Kabellos', 'Sans fil');
        if (/Type de raccordement:\s*C[âa]bl[ée]|filaire|wired|USB-A|USB-C/i.test(s)) return __sh_t('Kabelgebunden', 'Filaire');
        return null;
      }},
      { key: 'disposition', label: __sh_t('Layout', 'Disposition'), extract: function(t, p) {
        var s = (p && p.body_html ? p.body_html : '') + ' ' + t;
        if (/QWERTZ\s*\(CH\)|Suisse/i.test(s)) return __sh_t('QWERTZ Schweiz', 'QWERTZ Suisse');
        if (/QWERTZ\s*\(DE\)|Allemand/i.test(s)) return __sh_t('QWERTZ Deutsch', 'QWERTZ Allemand');
        if (/AZERTY/i.test(s)) return 'AZERTY';
        if (/QWERTY/i.test(s)) return 'QWERTY';
        return null;
      }},
      { key: 'marque', label: __sh_t('Marke', 'Marque'), extract: function(t) {
        var brands = ['Logitech','Razer','Corsair','SteelSeries','HyperX','ASUS','MSI','Keychron','Ducky','Turtle Beach','Trust','Cherry','Glorious','Roccat','Cooler Master','HP','Microsoft','Lenovo','Dell','Apple'];
        for (var b of brands) { if (t.toLowerCase().indexOf(b.toLowerCase()) !== -1) return b; }
        return null;
      }}
    ],
    'souris': [
      { key: 'connexion', label: __sh_t('Anschluss', 'Connexion'), extract: function(t, p) {
        var s = (p && p.body_html ? p.body_html : '') + ' ' + t;
        if (/Type de raccordement:\s*Sans c[âa]ble|sans[- ]fil|wireless|Bluetooth|2\.4\s*GHz|Lightspeed|HyperSpeed/i.test(s)) return __sh_t('Kabellos', 'Sans fil');
        if (/Type de raccordement:\s*C[âa]bl[ée]|filaire|wired|USB-A|USB-C/i.test(s)) return __sh_t('Kabelgebunden', 'Filaire');
        return null;
      }},
      { key: 'dpi', label: 'DPI max', extract: function(t, p) {
        var s = (p && p.body_html ? p.body_html : '') + ' ' + t;
        var m = s.match(/(\d{4,6})\s*dpi/i);
        if (!m) m = s.match(/sensibilit[ée][^:]*:\s*(\d{3,6})/i);
        if (!m) return null;
        var v = parseInt(m[1]);
        if (v >= 26000) return '26 000 DPI+';
        if (v >= 20000) return '20 000 DPI+';
        if (v >= 16000) return '16 000 DPI+';
        if (v >= 12000) return '12 000 DPI+';
        if (v >= 8000) return '8 000 DPI+';
        if (v >= 6000) return '6 000 DPI+';
        if (v >= 4000) return '4 000 DPI+';
        return __sh_t('Bis 4 000 DPI', 'Jusqu\'à 4 000 DPI');
      }},
      { key: 'capteur', label: __sh_t('Sensor', 'Capteur'), extract: function(t, p) {
        var s = (p && p.body_html ? p.body_html : '') + ' ' + t;
        if (/Type de capteur:\s*optique|capteur optique/i.test(s)) return __sh_t('Optisch', 'Optique');
        if (/Type de capteur:\s*laser|capteur laser/i.test(s)) return 'Laser';
        return null;
      }},
      { key: 'main', label: __sh_t('Hand', 'Main'), extract: function(t, p) {
        var s = (p && p.body_html ? p.body_html : '') + ' ' + t;
        if (/Position[^:]*:\s*Droitiers?\s*\/\s*Gauchers?|Ambidextre/i.test(s)) return __sh_t('Beidhändig', 'Ambidextre');
        if (/Position[^:]*:\s*Droitiers?/i.test(s)) return __sh_t('Rechtshänder', 'Droitier');
        if (/Position[^:]*:\s*Gaucher/i.test(s)) return __sh_t('Linkshänder', 'Gaucher');
        return null;
      }},
      { key: 'marque', label: __sh_t('Marke', 'Marque'), extract: function(t) {
        var brands = ['Logitech','Razer','Corsair','SteelSeries','HyperX','ASUS','MSI','Glorious','Pulsar','Endgame Gear','Roccat','Cooler Master','Trust','Turtle Beach','Microsoft','HP','Dell','Apple','Xiaomi'];
        for (var b of brands) { if (t.toLowerCase().indexOf(b.toLowerCase()) !== -1) return b; }
        return null;
      }}
    ],
    'ecrans': [
      { key: 'pouces', label: __sh_t('Zoll', 'Pouces'), extract: function(t, p) {
        var s = (p && p.body_html ? p.body_html : '');
        var m = s.match(/(?:Diagonale[^:<]*:|pouces[^:<]*:)\s*(\d{2}(?:[.,]\d)?)\s*"/i);
        if (m) return m[1].replace(',','.') + '"';
        m = s.match(/(\d{2}(?:[.,]\d)?)\s*"\s*\)/);
        if (m) return m[1].replace(',','.') + '"';
        m = t.match(/\b(\d{2})(?:i|"|inch|inches|cm)\b/i);
        if (m) { var v = parseInt(m[1]); if (v>=20 && v<=60) return v+'"'; }
        m = t.match(/\bG(\d{2})/);
        if (m) { var v = parseInt(m[1]); if (v>=20 && v<=60) return v+'"'; }
        return null;
      }},
      { key: 'refresh', label: __sh_t('Bildwiederholrate', 'Taux de rafraîchissement'), extract: function(t, p) {
        var s = (p && p.body_html ? p.body_html : '') + ' ' + t;
        var m = s.match(/(\d{2,3})\s*Hz/i);
        if (m) { var v = parseInt(m[1]); if (v>=50 && v<=600) return v+' Hz'; }
        return null;
      }},
      { key: 'resolution', label: __sh_t('Auflösung', 'Résolution'), extract: function(t, p) {
        var s = (p && p.body_html ? p.body_html : '') + ' ' + t;
        if (/7680\s*x\s*4320|8K/i.test(s)) return '8K';
        if (/5120\s*x\s*2160/i.test(s)) return '5K2K Ultrawide';
        if (/5120\s*x\s*1440/i.test(s)) return 'Dual QHD (5120x1440)';
        if (/3840\s*x\s*2160|Ultra\s*HD\s*4K|\b4K\b|UHD/i.test(s)) return '4K UHD';
        if (/3440\s*x\s*1440/i.test(s)) return 'Ultrawide 1440p';
        if (/2560\s*x\s*1440|WQHD|QHD|\b1440p\b|\b2K\b/i.test(s)) return '1440p (QHD)';
        if (/2560\s*x\s*1080|UWFHD/i.test(s)) return 'Ultrawide 1080p';
        if (/1920\s*x\s*1080|Full\s*HD|\bFHD\b|\b1080p\b/i.test(s)) return '1080p (Full HD)';
        return null;
      }},
      { key: 'dalle', label: __sh_t('Panel', 'Type de dalle'), extract: function(t, p) {
        var s = (p && p.body_html ? p.body_html : '') + ' ' + t;
        if (/\bOLED\b/i.test(s)) return 'OLED';
        if (/\bIPS\b/i.test(s)) return 'IPS';
        if (/\bVA\b/i.test(s)) return 'VA';
        if (/\bTN\b/i.test(s)) return 'TN';
        return null;
      }},
      { key: 'marque', label: __sh_t('Marke', 'Marque'), extract: function(t) {
        var brands = ['Samsung','LG','ASUS','MSI','AOC','Gigabyte','Acer','Dell','BenQ','ViewSonic','Philips','Iiyama','HP','Lenovo','Xiaomi','HKC','Huawei'];
        for (var b of brands) { if (t.toLowerCase().indexOf(b.toLowerCase()) !== -1) return b; }
        return null;
      }}
    ]
  };
  // Match collection handles that start with these
  var defs = FILTER_DEFS[COLL];
  if (!defs) {
    var keys = Object.keys(FILTER_DEFS);
    for (var i = 0; i < keys.length; i++) {
      if (COLL.indexOf(keys[i]) === 0 || keys[i].indexOf(COLL) === 0) {
        defs = FILTER_DEFS[keys[i]];
        break;
      }
    }
  }
  if (!defs) return;

  // Load ALL products
  async function loadAll() {
    var all = [], page = 1;
    while (true) {
      var resp = await fetch('/collections/' + COLL + '/products.json?limit=250&page=' + page);
      var data = await resp.json();
      if (!data.products || data.products.length === 0) break;
      all = all.concat(data.products);
      if (data.products.length < 250) break;
      page++;
    }
    return all;
  }

  // Normalize filter value (case insensitive dedup)
  function normalizeVal(v) {
    if (!v) return null;
    v = v.trim();
    if (!v) return null;
    return v;
  }

  // Build canonical key for dedup (lowercase)
  function canonKey(v) {
    return v.toLowerCase().replace(/[\s-]+/g, '');
  }

  loadAll().then(function(products) {
    // Build filter values with counts
    var filterData = {};
    defs.forEach(function(d) {
      var valMap = {}; // canonKey -> { display, count }
      products.forEach(function(p) {
        var val = normalizeVal(d.extract(p.title, p));
        if (val) {
          var ck = canonKey(val);
          if (!valMap[ck]) { valMap[ck] = { display: val, count: 0 }; }
          valMap[ck].count++;
        }
      });
      filterData[d.key] = valMap;
    });

    // Build filter UI
    var panel = document.getElementById('CollectionFilters');
    if (!panel) return;
    panel.innerHTML = '';

    // Add overlay for closing dropdowns
    var overlay = document.createElement('div');
    overlay.className = 'coll__filter-overlay';
    document.body.appendChild(overlay);

    var allDetails = [];

    defs.forEach(function(d) {
      var valMap = filterData[d.key];
      var vals = Object.keys(valMap);
      if (vals.length === 0) return;

      // Sort by count descending
      vals.sort(function(a, b) { return valMap[b].count - valMap[a].count; });

      var group = document.createElement('div');
      group.className = 'coll__filter-group';

      var details = document.createElement('details');
      allDetails.push(details);

      var summary = document.createElement('summary');
      summary.className = 'coll__filter-label';
      var labelText = document.createElement('span');
      labelText.textContent = d.label;
      summary.appendChild(labelText);
      details.appendChild(summary);
      var opts = document.createElement('div');
      opts.className = 'coll__filter-options';

      vals.forEach(function(ck) {
        var info = valMap[ck];
        var label = document.createElement('label');
        label.className = 'coll__filter-option';

        var cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.dataset.filterKey = d.key;
        cb.dataset.filterVal = ck;
        cb.addEventListener('change', function() {
          applyFilters();
          updateActiveStates();
        });

        var span = document.createElement('span');
        span.textContent = info.display + ' (' + info.count + ')';

        label.appendChild(cb);
        label.appendChild(span);
        opts.appendChild(label);
      });

      details.appendChild(opts);
      group.appendChild(details);
      panel.appendChild(group);

      // Close other dropdowns when opening one
      summary.addEventListener('click', function(e) {
        // Let the default toggle happen, then close others
        setTimeout(function() {
          if (details.open) {
            allDetails.forEach(function(dd) {
              if (dd !== details && dd.open) dd.open = false;
            });
            overlay.classList.add('is-active');
          } else {
            overlay.classList.remove('is-active');
          }
        }, 0);
      });
    });

    // Add reset button
    var resetBtn = document.createElement('button');
    resetBtn.className = 'coll__filter-reset';
    resetBtn.innerHTML = '&#x2715; Effacer';
    resetBtn.addEventListener('click', function() {
      panel.querySelectorAll('input[type=checkbox]:checked').forEach(function(cb) {
        cb.checked = false;
      });
      applyFilters();
      updateActiveStates();
    });
    panel.appendChild(resetBtn);

    // Close dropdown when clicking overlay
    overlay.addEventListener('click', function() {
      allDetails.forEach(function(dd) { dd.open = false; });
      overlay.classList.remove('is-active');
    });

    // Update active states (count badges on pills)
    function updateActiveStates() {
      var anyActive = false;
      allDetails.forEach(function(det) {
        var checked = det.querySelectorAll('input:checked');
        var existingBadge = det.querySelector('.coll__filter-count');
        if (existingBadge) existingBadge.remove();

        if (checked.length > 0) {
          det.classList.add('has-active');
          var badge = document.createElement('span');
          badge.className = 'coll__filter-count';
          badge.textContent = checked.length;
          det.querySelector('summary').appendChild(badge);
          anyActive = true;
        } else {
          det.classList.remove('has-active');
        }
      });
      resetBtn.classList.toggle('is-visible', anyActive);
    }
    // Apply filters
    function applyFilters() {
      var checked = panel.querySelectorAll('input[type=checkbox]:checked');
      var activeFilters = {};
      checked.forEach(function(cb) {
        var key = cb.dataset.filterKey;
        if (!activeFilters[key]) activeFilters[key] = [];
        activeFilters[key].push(cb.dataset.filterVal);
      });

      // Get product cards
      var cards = document.querySelectorAll('.coll__grid > a, .coll__grid > div > a');
      if (cards.length === 0) cards = document.querySelectorAll('[class*=card], [class*=pcard]');

      // Map products by title for matching
      var prodMap = {};
      products.forEach(function(p) {
        prodMap[p.title.toLowerCase().trim()] = p;
      });

      var visibleCount = 0;
      var noFilters = Object.keys(activeFilters).length === 0;

      cards.forEach(function(card) {
        var el = card.closest('.pcard') || card;
        if (noFilters) {
          el.style.display = '';
          visibleCount++;
          return;
        }

        // Find matching product
        var titleEl = el.querySelector('.pcard__name, h3, h2, [class*=title]');
        var cardTitle = titleEl ? titleEl.textContent.trim().toLowerCase() : '';
        var prod = prodMap[cardTitle];
        if (!prod) {
          // Try partial match
          for (var key in prodMap) {
            if (key.indexOf(cardTitle) !== -1 || cardTitle.indexOf(key) !== -1) {
              prod = prodMap[key];
              break;
            }
          }
        }

        var show = true;
        if (prod) {
          for (var fkey in activeFilters) {
            var fvals = activeFilters[fkey];
            var def = defs.find(function(dd) { return dd.key === fkey; });
            if (!def) continue;
            var pval = normalizeVal(def.extract(prod.title, prod));
            if (!pval) { show = false; break; }
            var pck = canonKey(pval);
            if (fvals.indexOf(pck) === -1) { show = false; break; }
          }
        } else {
          show = false;
        }

        el.style.display = show ? '' : 'none';
        if (show) visibleCount++;
      });

      updateCount(visibleCount);
    }

    // Update count text
    function updateCount(n) {
      var countEl = document.querySelector('.coll__count');
      if (!countEl) return;
      var isPc = COLL.indexOf('pc') === 0;
      countEl.textContent = n + (isPc ? (__SH_DE ? ' PCs verfügbar' : ' PC disponibles') : (__SH_DE ? ' Produkte verfügbar' : ' produits disponibles'));
    }

  });
})();

/* ===== MOBILE COLLECTION FILTER PANEL ===== */
(function() {
  if (window.innerWidth > 768) return;
  var filters = document.querySelector(".coll__filters");
  if (!filters) return;

  // Extract filter data from existing details elements
  var filterData = [];
  var groups = filters.querySelectorAll("details");
  var seen = {};
  groups.forEach(function(g) {
    var label = g.querySelector("summary");
    var labelText = label ? label.textContent.replace(/\d+$/, "").trim() : "";
    if (seen[labelText]) return;
    seen[labelText] = true;
    var options = [];
    g.querySelectorAll(".coll__filter-option").forEach(function(o) {
      options.push({ text: o.textContent.trim(), el: o });
    });
    if (options.length > 0) filterData.push({ label: labelText, options: options, detailsEl: g });
  });
  if (filterData.length === 0) return;

  // Create filter button
  var btn = document.createElement("button");
  btn.className = "coll-mobile-filter-btn";
  btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="20" y2="12"/><line x1="12" y1="18" x2="20" y2="18"/><circle cx="6" cy="12" r="2" fill="currentColor"/><circle cx="14" cy="18" r="2" fill="currentColor"/><circle cx="8" cy="6" r="2" fill="currentColor"/></svg> Filtrer';

  // Insert after hero header
  var toolbar = document.querySelector(".coll__toolbar");
  if (toolbar) toolbar.parentNode.insertBefore(btn, toolbar);

  // Create overlay
  var overlay = document.createElement("div");
  overlay.className = "coll-filter-overlay";
  document.body.appendChild(overlay);

  // Create panel
  var panel = document.createElement("div");
  panel.className = "coll-filter-panel";
  var panelHTML = '<div class="coll-filter-panel-header"><span class="coll-filter-panel-title">' + __sh_t('Filtern', 'Filtrer') + '</span><button class="coll-filter-panel-close">\u2715</button></div>';
  panelHTML += '<div class="coll-filter-panel-body">';
  filterData.forEach(function(f, idx) {
    panelHTML += '<div class="coll-fp-section"><span class="coll-fp-label">' + f.label + '</span><div class="coll-fp-options">';
    f.options.forEach(function(o, oi) {
      panelHTML += '<button class="coll-fp-chip" data-group="' + idx + '" data-idx="' + oi + '">' + o.text + '</button>';
    });
    panelHTML += '</div></div>';
  });
  panelHTML += '</div>';
  panelHTML += '<div class="coll-filter-panel-footer"><button class="coll-fp-reset">R\u00e9initialiser</button><button class="coll-fp-apply">Appliquer</button></div>';
  panel.innerHTML = panelHTML;
  document.body.appendChild(panel);

  // Open/close
  function openPanel() { overlay.classList.add("open"); panel.classList.add("open"); document.body.style.overflow = "hidden"; }
  function closePanel() { overlay.classList.remove("open"); panel.classList.remove("open"); document.body.style.overflow = ""; }
  btn.addEventListener("click", openPanel);
  overlay.addEventListener("click", closePanel);
  panel.querySelector(".coll-filter-panel-close").addEventListener("click", closePanel);

  // Chip selection
  panel.querySelectorAll(".coll-fp-chip").forEach(function(chip) {
    chip.addEventListener("click", function() {
      var grp = this.getAttribute("data-group");
      // Deselect others in same group
      panel.querySelectorAll('.coll-fp-chip[data-group="' + grp + '"]').forEach(function(c) { c.classList.remove("active"); });
      this.classList.toggle("active");
    });
  });

  // Apply — click the original filter options
  panel.querySelector(".coll-fp-apply").addEventListener("click", function() {
    var activeChips = panel.querySelectorAll(".coll-fp-chip.active");
    // Click original filter options
    activeChips.forEach(function(chip) {
      var gi = parseInt(chip.getAttribute("data-group"));
      var oi = parseInt(chip.getAttribute("data-idx"));
      if (filterData[gi] && filterData[gi].options[oi]) {
        filterData[gi].options[oi].el.click();
      }
    });
    // If no chips active, just close
    closePanel();
  });

  // Reset
  panel.querySelector(".coll-fp-reset").addEventListener("click", function() {
    panel.querySelectorAll(".coll-fp-chip.active").forEach(function(c) { c.classList.remove("active"); });
    // Click reset button if exists
    var resetBtn = document.querySelector(".coll__filter-reset");
    if (resetBtn) resetBtn.click();
    closePanel();
  });
})();
